import React from 'react';
import { Typography, Box } from '@mui/material';

const StatsCardRow = ({ stats }) => {
  return (
    <>
      <div
        className="col-xxl-12 d-flex flex-wrap"
        style={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          border: '1px solid #DFDFDF',
        }}
      >
        {stats.map((item, index) => (
          <Box
            key={index}
            className={`card-body ${index !== stats.length - 1 ? 'border-end' : 'border-end-0'} d-flex flex-column justify-content-center my-24 mx-12`}
            style={{ flex: '0 0 0 100px', minWidth: '100px' }}
          >
            <div>
              <span
                className="mb-1 fw-medium text-secondary-light text-sm"
                style={{ fontFamily: 'Manrope', fontSize: '14px' }}
              >
                {item.label}
              </span>
              <Typography
                sx={{
                  fontSize: { xl: '35px', lg: '35px', md: '30px', sm: '24px', xs: '30px' },
                  fontWeight: '600',
                  color: item.color || '#373737',
                  lineHeight: '1',
                  fontFamily: 'Manrope',
                }}
              >
                {item.value}
              </Typography>
            </div>
          </Box>
        ))}
      </div>
    </>

  );
};

export default StatsCardRow;
